import React from "react"
import { Container, Card, Row, Col, CardBody, CardHeader, Button, FormFeedback } from "reactstrap";
import { ErrorMessage } from "formik"
import InputField from "../Utils/InputField";
import SelectField from "../Utils/SelectField";
import { LabelText } from "../Utils/Input";
import { handleChangeForEndDateOfUom, handleChangeForStartDateOfUom, handleChangeForUom } from "./constants/HandleChangeFunctions";
import CommonButton from "../Utils/CommonButton";
import CommonDateTimePicker from "../Utils/CommonDateTimePicker";
import moment from "moment";

export default function SimulatePage({
    touched, setRenderSimulate,
    errors,
    values,
    setFieldTouched, setStartDate,
    setFieldValue,
    handleBlur,
    handleChange,
    options,
    startDate,
    setSelectedUom,
    handleStartDateChange
}) {
    const dateTimeFormat = `${localStorage.getItem("dateFormat") || "DD MMM YYYY"}  hh:mm A`;
    return (
        <Container fluid>
            <Row>
                <Col xs={12}>

                    <div className="live-preview mx-3">
                        <Row className="gy-4">
                            <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                                <LabelText htmlFor={"eventType"} className={"text-danger"} displayText={"Event Type"} important={"*"} />
                                <LabelText
                                    htmlFor={"eventType"}
                                    classLabelName={`d-block ms-0 rv-sub-label ${touched.eventType && errors.eventType
                                        ? "rv-label-danger"
                                        : "rv-label-muted"
                                        } `}
                                    displayText={
                                        touched.eventType && errors.eventType
                                            ? errors.eventType
                                            : "Enter Event Type"
                                    }
                                />
                                <InputField name={"eventType"} type={"text"} className={"form-control"} id={"eventType"} handleChange={handleChange} handleBlur={handleBlur} value={values.eventType}
                                    invalid={touched.eventType && errors.eventType
                                        ? true
                                        : false} />
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                                <LabelText htmlFor={"uom"} className={"text-danger"} displayText={"UOM"} important={"*"} />
                                <LabelText
                                    htmlFor={"uom"}
                                    classLabelName={`d-block ms-0 rv-sub-label ${touched.uom && errors.uom
                                        ? "rv-label-danger"
                                        : "rv-label-muted"
                                        } `}
                                    displayText={
                                        touched.uom && errors.uom
                                            ? errors.uom
                                            : "Select UOM"
                                    }
                                />
                                <SelectField options={options}
                                    className={(errors.uom && touched.uom) ? 'error-input' : ''}
                                    placeholder={" "}
                                    value={values.uom || ""}
                                    handleChange={handleChangeForUom(setSelectedUom, setFieldTouched, setFieldValue)}
                                    isRVStyle={true}
                                />
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                                <LabelText htmlFor={"usageValue"} className={"text-danger"} displayText={"Usage Value"} important={"*"} />
                                <LabelText
                                    htmlFor={"usageValue"}
                                    classLabelName={`d-block ms-0 rv-sub-label ${touched.usageValue && errors.usageValue
                                        ? "rv-label-danger"
                                        : "rv-label-muted"
                                        } `}
                                    displayText={
                                        touched.usageValue && errors.usageValue
                                            ? errors.usageValue
                                            : "Enter Usage Value"
                                    }
                                />
                                <InputField name={"usageValue"} type={"text"} className={"form-control"} id={"usageValue"} handleChange={handleChange} handleBlur={handleBlur} value={values.usageValue}
                                    invalid={touched.usageValue && errors.usageValue
                                        ? true
                                        : false} />
                            </Col>
                            <Col xs={12} sm={12}>
                            <Row className="gy-3">
                                <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                                    <LabelText htmlFor={"eventStartTime"} className={"text-danger"} displayText={"Start Time"} important={"*"} />
                                    <LabelText
                                        htmlFor={"eventStartTime"}
                                        classLabelName={`d-block ms-0 rv-sub-label ${touched.eventStartTime && errors.eventStartTime
                                            ? "rv-label-danger"
                                            : "rv-label-muted"
                                            } `}
                                        displayText={
                                            touched.eventStartTime && errors.eventStartTime
                                                ? errors.eventStartTime
                                                : "Select Start Time"
                                        }
                                    />
                                    <CommonDateTimePicker
                                        className={`form-control ${touched.eventStartTime &&
                                            !values.eventStartTime ? (
                                            "error-input"
                                        ) : ""}`}
                                        value={values.eventStartTime}
                                        name={`eventStartTime`}
                                        format={dateTimeFormat}
                                        handleChange={handleChangeForStartDateOfUom(values, handleStartDateChange, setStartDate, setFieldTouched)}
                                    />
                                </Col>
                                <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                                    <LabelText htmlFor={"eventEndTime"} className={"text-danger"} displayText={"End Time"} important={"*"} />
                                    <LabelText
                                        htmlFor={"eventEndTime"}
                                        classLabelName={`d-block ms-0 rv-sub-label ${touched.eventEndTime && errors.eventEndTime
                                            ? "rv-label-danger"
                                            : "rv-label-muted"
                                            } `}
                                        displayText={
                                            touched.eventEndTime && errors.eventEndTime
                                                ? errors.eventEndTime
                                                : "Select End Time"
                                        }
                                    />
                                    <CommonDateTimePicker
                                        value={values.eventEndTime}
                                        handleChange={handleChangeForEndDateOfUom(values, setFieldTouched)}
                                        className={`form-control ${touched.eventEndTime &&
                                            !values.eventEndTime ? (
                                            "error-input"
                                        ) : ""}`}
                                        format={dateTimeFormat}
                                        name={`eventEndTime`}
                                        minDateTime={values.eventStartTime}
                                    />
                                </Col>
                            </Row>
                            </Col>
                        </Row>
                        <Row lg={12} className=" justify-content-center mb-4 mt-4">
                            <div className="live-preview">
                                <div className="d-flex justify-content-center gap-2 ">
                                    <CommonButton
                                        outline
                                        type="reset"
                                        className={
                                            "btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-md-auto text-nowrap"
                                        }
                                        color={"main-color"}
                                        buttonAction={() => setRenderSimulate(false)}
                                        buttonText={"Close"}
                                        icon={
                                            <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                        }
                                        btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                                    />
                                    <CommonButton
                                        color={"main-color"}
                                        className={
                                            "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-md-auto text-nowrap"
                                        }
                                        icon={
                                            <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-2"></i>
                                        }
                                        btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                                        type="submit"
                                        buttonText={"Submit"}
                                    />
                                </div>
                            </div>
                        </Row>
                    </div>

                </Col>
            </Row>
        </Container>
    )
}